<script>

export default {
  name: 'PaymentReceiptApiMixin',
  computed: {
    getRelayHeaderList () {
      return []
    },
    tableHeaders () {
      return []
    },
    getPaymentErrorList () {
      return [
        {
          id: 'invalid-end-date',
          title: 'Чек создан до завершения смены',
          description: 'Чек создан до завершения смены',
        },
        {
          id: 'invalid-service',
          title: 'Неверное наименование услуги',
          description: 'Неверное наименование услуги',
        },
        {
          id: 'duplicate',
          title: 'Чек ранее уже был прикреплен к другой смене (дубль)',
          description: 'Чек ранее уже был прикреплен к другой смене (дубль)',
        },
        {
          id: 'invalid-date',
          title: 'Неверная дата продажи',
          description: 'Неверная дата продажи',
        },
        {
          id: 'invalid-laborer-inn',
          title: 'Неверный ИНН исполнителя',
          description: 'Неверный ИНН исполнителя',
        },
        {
          id: 'invalid-provider-inn',
          title: 'Неверный ИНН организации-покупателя',
          description: 'Неверный ИНН организации-покупателя',
        },
        {
          id: 'canceled',
          title: 'Чек аннулирован',
          description: 'Чек аннулирован',
        },
        {
          id: 'invalid-amount',
          title: 'Неверная сумма в чеке',
          description: 'Неверная сумма в чеке',
        },
      ]
    },
    getStatusList () {
      return [
        {
          id: 'created',
          title: 'Новый',
          description: 'Чек создан до завершения смены',
        },
        {
          id: 'active',
          title: 'В работе',
          description: 'Неверное наименование услуги',
        },
        {
          id: 'rejected',
          title: 'Отклонен',
          description: 'Чек ранее уже был прикреплен к другой смене (дубль)',
        },
        {
          id: 'done',
          title: 'Закрыт',
          description: 'Неверная дата продажи',
        },
      ]
    },
  },
  methods: {
  }
}
</script>
